import { Badge, DialogBody, Table, Tabs } from "@chakra-ui/react"
import { Parts, UI } from "components"
import { Styles } from "config"
import useNetworkCareersReport from "hooks/useNetworkCareersReport"
import useNetworkReport from "hooks/useNetworkReport"
import moment from "moment"
import { useState } from "react"

export default function Pins(props){

    const report = useNetworkReport()

    return(
    <UI.Dialog title="Relatório de Pins" size="xl" {...props}>
        <DialogBody>

            <Tabs.Root size="sm" defaultValue={1}>
                <Tabs.List>
                    { report.data?.careers?.map(item => item?.count <= 0 ? <></> : <Tabs.Trigger key={item.career.id} value={item.career.id} colorPalette={Styles.pin(item.career.id).colorPalette}>{item.career.title}</Tabs.Trigger>)}
                </Tabs.List>
                { report.data?.careers?.map(item => item?.count <= 0 ? <></> : <Tabs.Content key={item.career.id} value={item.career.id}><TableReport data={item.career} /></Tabs.Content>)}
                
                <Tabs.Content value="Expert">Expert</Tabs.Content>
            </Tabs.Root>

        </DialogBody>
    </UI.Dialog>
    )
}

const TableReport = ({ data }) => {

    const report = useNetworkCareersReport(data.id)
    const [ downline, setDownline ] = useState(false)
    const columns = [{ children: 'Nome' }, { children: 'E-mail' }, { children: 'Data do cadastro' }]

    return(
    <>
        <Parts.Dialog.Network.Downline open={!!downline} data={downline} onClose={() => setDownline(false)} />
        <UI.Table interactive loading={report.isFetching} columns={columns} data={report.data} Row={Item} onRowClick={setDownline} />
    </>
    )
}

const Item = ({ data, onClick, ...props }) => {

    return(
    <Table.Row cursor="pointer" onClick={() => onClick(data)} {...props}>
        <Table.Cell textTransform="capitalize">{data.name}</Table.Cell>
        <Table.Cell><Badge>{data.level}</Badge></Table.Cell>
        <Table.Cell>Consultor desde {moment(data.created_at).format('Y')}</Table.Cell>
    </Table.Row>
    )
}